import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableIncomplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 400,
	height: 347,
	viewBox: "0 0 400 347",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 56H392V57H8V56Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 113H392V114H8V113Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 170H392V171H8V170Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 227H392V228H8V227Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 284H392V285H8V284Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M207 285H208V14H207V285Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M344 85C344 78.4 349.4 73 356 73H375C381.6 73 387 78.4 387 85C387 91.6 381.6 97 375 97H356C349.4 97 344 91.6 344 85Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M321 142C321 135.4 326.4 130 333 130H375C381.6 130 387 135.4 387 142C387 148.6 381.6 154 375 154H333C326.4 154 321 148.6 321 142Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M331 256C331 249.4 336.4 244 343 244H375C381.6 244 387 249.4 387 256C387 262.6 381.6 268 375 268H343C336.4 268 331 262.6 331 256Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M331 313C331 306.4 336.4 301 343 301H375C381.6 301 387 306.4 387 313C387 319.6 381.6 325 375 325H343C336.4 325 331 319.6 331 313Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 85C14 78.4 19.4 73 26 73H142C148.6 73 154 78.4 154 85C154 91.6 148.6 97 142 97H26C19.4 97 14 91.6 14 85Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 255C14 248.4 19.4 243 26 243H158C164.6 243 170 248.4 170 255C170 261.6 164.6 267 158 267H26C19.4 267 14 261.6 14 255Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 142C14 135.4 19.4 130 26 130H84C90.6 130 96 135.4 96 142C96 148.6 90.6 154 84 154H26C19.4 154 14 148.6 14 142Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 200C14 193.4 19.4 188 26 188H59C65.6 188 71 193.4 71 200C71 206.6 65.6 212 59 212H26C19.4 212 14 206.6 14 200Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M249 200C249 193.4 254.4 188 261 188H294C300.6 188 306 193.4 306 200C306 206.6 300.6 212 294 212H261C254.4 212 249 206.6 249 200Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M330.5 200C330.5 193.4 335.9 188 342.5 188H375.5C382.1 188 387.5 193.4 387.5 200C387.5 206.6 382.1 212 375.5 212H342.5C335.9 212 330.5 206.6 330.5 200Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M236 142C236 135.4 241.4 130 248 130H294C300.6 130 306 135.4 306 142C306 148.6 300.6 154 294 154H248C241.4 154 236 148.6 236 142Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M226 85C226 78.4 231.94 73 239.2 73H289.8C297.06 73 303 78.4 303 85C303 91.6 297.06 97 289.8 97H239.2C231.94 97 226 91.6 226 85Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M264 256C264 249.4 269.4 244 276 244H294C300.6 244 306 249.4 306 256C306 262.6 300.6 268 294 268H276C269.4 268 264 262.6 264 256Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 32H67C69.2 32 71 33.8 71 36C71 38.2 69.2 40 67 40H18C15.8 40 14 38.2 14 36C14 33.8 15.8 32 18 32Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M264 32H301C303.2 32 305 33.8 305 36C305 38.2 303.2 40 301 40H264C261.8 40 260 38.2 260 36C260 33.8 261.8 32 264 32Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M26.4004 299.8H35.5004V302.1H32.4004V311.6H29.5004V302.1H26.4004V299.8Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.2004 311.7C38.4004 311.7 36.4004 309.9 36.4004 306.9C36.4004 303.9 38.5004 302.1 41.3004 302.1C44.1004 302.1 46.2004 303.9 46.2004 306.9C46.2004 309.9 44.0004 311.7 41.2004 311.7ZM41.2004 309.2C42.2004 309.2 43.2004 308.4 43.2004 306.9C43.2004 305.3 42.3004 304.6 41.2004 304.6C40.2004 304.6 39.2004 305.3 39.2004 306.9C39.3004 308.4 40.2004 309.2 41.2004 309.2Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M48.1 304.6H47V302.2H48.1V299.9H51V302.2H52.9V304.6H51V308.4C51 309 51.2 309.2 51.9 309.2H52.9V311.6H51.4C49.4 311.6 48.1 310.8 48.1 308.3V304.6Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.1008 302C59.5008 302 60.5008 302.6 61.0008 303.5V302.2H63.9008V311.6H61.0008V310.3C60.5008 311.1 59.5008 311.8 58.1008 311.8C55.8008 311.8 54.0008 309.9 54.0008 307C53.9008 303.9 55.8008 302 58.1008 302ZM58.9008 304.5C57.8008 304.5 56.8008 305.3 56.8008 306.8C56.8008 308.3 57.8008 309.1 58.9008 309.1C60.0008 309.1 61.0008 308.3 61.0008 306.8C61.0008 305.3 60.0008 304.5 58.9008 304.5Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M65.9004 299.1H68.8004V311.5H65.9004V299.1Z",
					fill: "white"
				})
			]
		})
	]
});
export default SvgTableIncomplete;
